import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import NotFound from 'components/NotFound';
import PageWithSidebar from 'components/PageWithSidebar';
import EntitySidebar from 'components/EntitySidebar';
import MenuItemsEditForm from 'components/MenuItemsEditForm';

import { withData } from 'lib';
import { ContentMenuItemEditPageQuery } from '__generated__/ContentMenuItemEditPageQuery.graphql';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import FormSkeleton from 'components/FormSkeleton';

const query = graphql`
  query ContentMenuItemEditPageQuery($id: ID!) {
    menuItem(id: $id) {
      name

      menu {
        id
        displayName
      }

      ...EntitySidebar_entity
      ...MenuItemsEditForm_menuItem
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<ContentMenuItemEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [
  { link: '/content', name: 'Turinys' },
  { link: '/content/menu', name: 'Meniu' },
];

const ContentMenuItemEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { menuItem } = usePreloadedQuery<ContentMenuItemEditPageQuery>(
    query,
    preloadedQuery
  );

  if (!menuItem) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<EntitySidebar entity={menuItem} />}
      breadcrumbs={[
        ...breadcrumbs,
        {
          link: `/content/menu/${menuItem.menu.id}`,
          name: menuItem.menu.displayName,
        },
        { name: menuItem.name },
      ]}>
      <MenuItemsEditForm menuItem={menuItem} />
    </PageWithSidebar>
  );
};

export default withData<ContentMenuItemEditPageQuery, RouteParams>({
  query,
  loading: (
    <EntityEditPageSkeleton breadcrumbs={breadcrumbs}>
      <FormSkeleton sections={1} />
    </EntityEditPageSkeleton>
  ),

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(ContentMenuItemEditPage);
